// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ReconciliationImportController = function (
    $scope,
    $location,
    gettextCatalog,
    gettext,
    ReconciliationImport,
    $rootScope,
    ReconciliationImportHistoryService,
    CommonObjects) {
    const defaultAllowedSize = 100000;
    $scope.isOperated = false;
    $scope.isUploadingStarted = false;
    $scope.isFirstOpen = true;
    $scope.paginationIsOn = false;
    $scope.actionPathParams = {
        currency: '',
        fileFormat: ''
    };

    $scope.openedItems = [];
    $scope.importLog = [];

    $scope.requiredToUpdate = true;

    $scope.attachment = setupBlankAttachment();
    $scope.isError = false;
    $scope.errorMessage = '';
    $scope.chosenFileText = gettextCatalog.getString(gettext("No file chosen"));
    $scope.allowedUploadSize = 100000;

    var getLog = function () {

        $scope.importLogPaginator = $scope.paginator(function (options, callback) {
            return ReconciliationImport.query(options, function (data)  {
                if(!$scope.openedItems) {
                    $scope.openedItems = [];
                }

                callback();
                $scope.importLog = data;
                ReconciliationImportHistoryService.processPreviouslyOpenedElements($scope.importLog, $scope.openedItems);

                if(ReconciliationImportHistoryService.areAllItemsInTerminalPhase(data)) {
                    $scope.requiredToUpdate = false;
                }
            });
        }, {}, 20);
    };

    getLog();

    var source = Rx.Observable
        .interval(10000)
        .timeInterval();

    var subscription = source.subscribe(
        function (x) {
            if(!$scope.requiredToUpdate){
                return;
            }

            getLog();
        });

    $scope.$on("$destroy", function handler() {
        subscription.dispose();
    });

    $scope.uploadCompleted = function (data) {
        resetFilesSelection();

        if (!data) {
            $scope.successMessage = null;
            return;
        }
        if (data.IsSuccess) {
            $scope.successMessage = gettextCatalog.getString(gettext("Import has been finished successfully"));
            $scope.transactionsFound = data.AlreadyImportedCount + data.ImportedAndAssignedCount + data.ImportedAndNotAssignedCount;
            $scope.transactionsAlreadyImported = data.AlreadyImportedCount;
            $scope.transactionsImportedAndAssigned = data.ImportedAndAssignedCount;
            $scope.transactionsImportedAndNotAssigned = data.ImportedAndNotAssignedCount;
            $scope.linesOperated = data.OperatedLinesCount;
            $scope.linesWithParsingErrors = data.LinesWithParsingErrors;
            $scope.ignoredTransactions = data.OperatedLinesCount - data.AlreadyImportedCount - data.ImportedAndAssignedCount - data.ImportedAndNotAssignedCount - data.LinesWithParsingErrors;

            $scope.requiredToUpdate = true;
        } else if (data.message) {
            $scope.errorMessage = gettextCatalog.getString(gettext("Upload error")) + ': ' + data.message;
            $scope.successMessage = null;
        }

        $scope.isOperated = true;
        $scope.isUploadingStarted = false;

        if (!data.IsSuccess && !data.message && data.Message) {
            $rootScope.showErrorBox(data.Message);
            $scope.continue();
        }
    };

    $scope.back = function () {
        $location.path("/activities/reconciliation");
        return false;
    };

    $scope.startUploading = function () {
        $scope.successMessage = null;
        $scope.isUploadingStarted = true;
    };

    $scope.continue = function () {
        $scope.errorMessage = '';
        $scope.isOperated = false;
    };

    $scope.getActionPath = function () {
        return '/reconciliationupload/upload?currency=' + encodeURIComponent($scope.actionPathParams.currency) + '&fileformat=' + encodeURIComponent($scope.actionPathParams.fileFormat)
            + '&selected_legal_entity_id=' + encodeURIComponent($rootScope.chosenEntity.Id);
    };

    $scope.ReconciliationImportMode = ReconciliationImportHistoryService.RECONCILIATION_IMPORT_MODE;

    $scope.toggleImportInfoVisibility = function(importItem, index) {
        ReconciliationImportHistoryService.toggleOpenedItem($scope.openedItems,importItem.Id);

        if(index == 0 &&  $scope.isFirstOpen)
        {
            $scope.isFirstOpen = false;
        }
        else
        {
            ReconciliationImportHistoryService.toggleImportInfoVisibility(importItem);
        }
    };

    $scope.setHistoryItemHeader = function (importItem) {
        return ReconciliationImportHistoryService.setHistoryItemHeader(importItem);
    };

    $scope.IsListEmpty = function (list) {
        return ReconciliationImportHistoryService.IsListEmpty(list);
    };

    $scope.getProcessingStatusClass = function (statusValue) {
        return ReconciliationImportHistoryService.getProcessingStatusClass(statusValue);
    };

    $scope.showSpecificError = function(errorMessage) {

        ReconciliationImportHistoryService.showSpecificError(errorMessage);
    };

    $scope.getStatusFileColumnMessage = function (item) {

        return ReconciliationImportHistoryService.getStatusFileColumnMessage(item);
    };

    $scope.$watch('attachment', function (newValue, oldValue) {
        if (newValue && newValue.Files && newValue.Files['_c'] && newValue.Files['_c'].FileName && newValue.Files['_c'].FileName.length > 0) {
            $scope.getChosenFileText(newValue.Files['_c'].FileName);
        }
        else {
            $scope.getChosenFileText(null);
        }
    }, true);

    $scope.$watch('errorResponse', function (newValue) {
        $scope.uploadCompleted($scope.errorResponse);
    });

    $scope.$watch('errorMessage', function (newValue) {
        if (newValue) {
            resetFilesSelection();
            $rootScope.showErrorBox(newValue);
            $scope.continue();
        }
    });

    $scope.$watch('actionPathParams.fileFormat', function (newValue, oldValue) {
        if (newValue) {
            switch (newValue) {
                case 'Camt053':
                    $scope.allowedUploadSize = 500000;
                    break;
                case 'Adyen':
                default:
                    $scope.allowedUploadSize = defaultAllowedSize;
                    break;
            }
        }
    });

    $scope.onSuccessCallback = function () {
        $scope.uploadCompleted($scope.successResponse);
    };

    $scope.saveUpload = function () {
        $scope.successResponse = '';
        if ($scope.isSavingForbidden()) {
            $scope.errorMessage = 'Nothing to save yet. Please choose a file first.';
        } else {
            $scope.startUploading();
            $scope.saveFunc();
        }
    };

    $scope.isSavingForbidden = function () {
        var fileName = $scope.attachment.Files['_c'].FileName;
        return (!fileName || fileName.length === 0);
    };

    $scope.getFileUploaderText = function () {
        return gettextCatalog.getString(gettext('Choose file'));
    };

    $scope.getChosenFileText = function (fileName) {
        $scope.chosenFileText = fileName ? fileName : gettextCatalog.getString(gettext("No file chosen"));
    }

    $scope.dataInvalid = function () {
        return $scope.isSavingForbidden();
    };

    function resetFilesSelection() {
        $scope.attachment = setupBlankAttachment();
    };

    function setupBlankAttachment() {
        return CommonObjects.BlankAttachment.get();
    };
};

ReconciliationImportController.$inject = ['$scope', '$location', 'gettextCatalog', 'gettext', 'ReconciliationImport', '$rootScope', 'ReconciliationImportHistoryService', 'CommonObjects'];
